'use strict';

import { Component } from 'react';
import { connectScrollTo } from 'react-instantsearch-dom';

class ScrollTo extends Component {
	componentDidUpdate(prev_props) {
		const { value, hasNotChanged } = this.props;
		if (value !== prev_props.value && hasNotChanged) {
			window.scrollTo(0, 0);
		}
	}
	
	render() {
		return <div>{ this.props.children }</div>;
	}
}

export default connectScrollTo(ScrollTo);
